<template>
  <div class="row mt-4">
    <div class="col-3"></div>
    <div class="col">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th class="text-center">MSRP</th>
            <th class="text-center">Options</th>
            <th class="text-center">Delivery Charge</th>
            <th class="text-center">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-right">{{ msrp }}</td>
            <td class="text-right">{{ optionsMsrp }}</td>
            <td class="text-right">{{ deliveryCharges }}</td>
            <td class="text-right">{{ combinedMsrp }}</td>
          </tr>
          <tr v-if="dealerInvoice">
            <td colspan="3" class="text-end">Dealer Invoice:</td>
            <td class="text-right">{{ dealerInvoice }}</td>
          </tr>
          <tr v-if="gotPricing">
            <td colspan="3" class="text-end">Actual Current Value (ACV):</td>
            <td class="text-right">{{ currentValue }}</td>
          </tr>
          <tr v-else>
            <td colspan="2">
              <div class="input-group">
                <span class="input-group-text">Postal Code</span>
                <input type="text" id="postalCode" v-model="postalCode" class="form-control" />
                <span class="input-group-text">Mileage</span>
                <input type="text" id="mileage" v-model="mileage" class="form-control" />
              </div>
            </td>
            <td colspan="2" class="text-end">
              <button class="btn btn-sm btn-primary" :disabled="!isValid || isLoading" @click="fetchCurrentPricing()">
                <FontAwesomeIcon v-if="isLoading" icon="fa-solid fa-spinner" spin />
                Get Current Pricing
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-3"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { buildStore } from '@/stores/build'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import globals from '@/plugins/globals'
export default {
  name: 'pricing',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      postalCode: null,
      mileage: 0,
      isLoading: false
    }
  },
  mounted() {
    this.isLoading = false
  },
  computed: {
    ...mapState(buildStore, ['build', 'currentPrice']),
    msrp() {
      let _data = null
      if (this.build) {
        _data = `$ ${globals.formatMoney(this.build.msrp)}`
      }
      return _data
    },
    optionsMsrp() {
      let _data = null
      if (this.build) {
        _data = `$ ${globals.formatMoney(this.build.installed_options_msrp)}`
      }
      return _data
    },
    deliveryCharges() {
      let _data = null
      if (this.build) {
        _data = `$ ${globals.formatMoney(this.build.delivery_charges)}`
      }
      return _data
    },
    combinedMsrp() {
      let _data = null
      if (this.build) {
        _data = `$ ${globals.formatMoney(this.build.combined_msrp)}`
      }
      return _data
    },
    dealerInvoice() {
      let _data = null
      if (this.build) {
        if (this.build.installed_equipment) {
          if (this.build.installed_equipment['STANDARD']) {
            let found = this.build.installed_equipment['STANDARD'].find(x => x.item === 'Dealer Invoice')
            if (found) {
              _data = `$ ${globals.formatMoney(found.value)}`
            }
          }
        }
      }
      return _data
    },
    gotPricing() {
      return this.currentPrice !== null
    },
    currentValue() {
      let _data = null
      if (this.currentPrice) {
        _data = `$ ${globals.formatMoney(this.currentPrice.marketcheck_price)}`
      }
      return _data
    },
    isValid() {
      return this.postalCode && this.mileage
    }
  },
  methods: {
    ...mapActions(buildStore, ['getCurrentPricing']),
    async fetchCurrentPricing() {
      this.isLoading = true
      let data = {
        vin: this.build.vin,
        zip: this.postalCode,
        miles: this.mileage
      }
      await this.getCurrentPricing(data)
      this.isLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-item {
  width: 100%;
}
</style>
